/* ==== MM / Sticky CTA — JS ================================================
   La barre d'achat collante (Figma 11777-474879 / 474898 / 474983).

   1. Apparition : un IntersectionObserver surveille le CTA de référence
      (data-sticky-target). Sans IntersectionObserver, repli sur scroll +
      resize ; sans cible trouvée, la barre reste affichée (aperçu, page
      sans CTA principal).
   2. Dépliement mobile : le bouton rond ouvre le panneau (voile, croix,
      tailles à plat, CTA) ; la croix, le voile, Échap et le passage en
      desktop le referment. Le verrou de scroll est rendu SANS écraser
      celui d'un panneau mm-panel ouvert (le guide des tailles s'ouvre
      depuis la barre).
   3. Prix : suit le variant sélectionné via data-product-reload (même
      mécanisme HTML-swap que le reste du product form), pas de câblage JS
      dédié ici. Ce swap fait un outerHTML sur .mm-pcta (mm_main_product.js) :
      le node observé par l'IntersectionObserver est détruit/remplacé, donc
      on ré-observe la cible fraîche à chaque product:product-reload-complete.
   4. Footer : un second IntersectionObserver surveille .shopify-section-
      group-footer-group et pose .is-footer-visible pour effacer la barre
      plutôt qu'elle ne flotte par-dessus (même pattern que mm_pack_funnel.js). */
	  (function () {
		'use strict';
	  
		function isMobile() { return window.isSmallDesktop(); }
	  
		function setup(root) {
		  if (root.hasAttribute('data-mm-sticky-ready')) return;
		  root.setAttribute('data-mm-sticky-ready', '');
	  
		  var openers = root.querySelectorAll('[data-sticky-open]');
		  var closers = root.querySelectorAll('[data-sticky-close]');
		  var closeBtn = root.querySelector('.mm-sticky__close');

		  var target = null;
		  var selector = root.getAttribute('data-sticky-target');
		  if (selector) {
			try { target = document.querySelector(selector); } catch (e) { target = null; }
		  }
	  
		  /* ---- dépliement mobile ------------------------------------------- */
		  var body = root.querySelector('.mm-sticky__body');
	  
		  /* Le rail 0fr→1fr clippe son contenu — sinon il déborderait pendant
			 l'ouverture. Une fois la transition FINIE, ce clipping n'a plus lieu
			 d'être et rognait le spring du CTA au survol : .is-settled le lève,
			 et la fermeture le rétablit avant que le rail ne bouge. */
		  function settle(e) {
			if (e && e.propertyName !== 'grid-template-rows') return;
			if (root.classList.contains('is-expanded')) root.classList.add('is-settled');
		  }
		  /* transitionend + filet de sécurité : l'événement n'arrive pas si la
			 transition est annulée ou si l'onglet ne peint pas (arrière-plan) —
			 sans le timer, le CTA resterait rogné dans ces cas-là */
		  if (body) body.addEventListener('transitionend', settle);
	  
		  function expand(open) {
			if (open && !isMobile()) return;
			if (!open) root.classList.remove('is-settled');
			root.classList.toggle('is-expanded', open);
			if (open) window.setTimeout(settle, 700); /* filet : > 0.55s d'ouverture */
			openers.forEach(function (o) { o.setAttribute('aria-expanded', open ? 'true' : 'false'); });
	  
			/* un panneau du kit (guide des tailles…) peut avoir posé le verrou :
			   on ne le lève pas à sa place — quel que soit l'ordre des écouteurs */
			var locked = open || !!document.querySelector('.mm-panel.is-open');
			document.documentElement.style.overflow = locked ? 'hidden' : '';
	  
			if (open && closeBtn) closeBtn.focus();
		  }
	  
		  openers.forEach(function (o) { o.addEventListener('click', function () { expand(true); }); });
		  closers.forEach(function (c) { c.addEventListener('click', function () { expand(false); }); });
	  
		  /* le guide des tailles s'ouvre par-dessus : la barre se replie d'abord */
		  root.querySelectorAll('[data-panel-open]').forEach(function (btn) {
			btn.addEventListener('click', function () { expand(false); });
		  });
	  
		  document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && root.classList.contains('is-expanded')) expand(false);
		  });
	  
		  /* ---- apparition --------------------------------------------------- */
		  var inner = root.querySelector('.mm-sticky__inner');

		  function syncAccess() {
			if (!inner) return;
			var active = root.classList.contains('is-visible') && !root.classList.contains('is-footer-visible');
			inner.inert = !active;
			document.documentElement.style.scrollPaddingBottom = active ? (inner.offsetHeight + parseFloat(getComputedStyle(root).paddingBottom || 0)) + 'px' : '';
		  }

		  function show(visible) {
			root.classList.toggle('is-visible', visible);
			if (!visible) expand(false);
			syncAccess();
		  }
	  
		  var observer = null;
		  var sync = null;

		  /* data-product-reload (mm_main_product.js) remplace le CTA cible via
			 outerHTML — le node observé se retrouve détaché du DOM et n'intersecte
			 plus jamais rien. On ré-observe le node courant à chaque reload. */
		  function observeTarget() {
			if (observer) { observer.disconnect(); observer = null; }
			if (sync) {
			  window.removeEventListener('scroll', sync);
			  window.removeEventListener('resize', sync);
			  sync = null;
			}

			if (target && typeof window.IntersectionObserver === 'function') {
			  var mobile = isMobile();
			  observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) { show(mobile ? !entry.isIntersecting : entry.intersectionRatio < 0.5); });
			  }, mobile ? { rootMargin: '0px 0px 100000px 0px' } : { threshold: [0, 0.5] });
			  observer.observe(target);
			} else if (target) {
			  /* repli sans IntersectionObserver : même règle, mesurée à la main */
			  sync = function () {
				var r = target.getBoundingClientRect();
				var seen = Math.max(0, Math.min(r.bottom, window.innerHeight || document.documentElement.clientHeight) - Math.max(r.top, 0));
				show(isMobile() ? r.bottom < 0 : seen < r.height / 2);
			  };
			  window.addEventListener('scroll', sync, { passive: true });
			  window.addEventListener('resize', sync);
			  sync();
			} else {
			  show(true);
			}
		  }

		  syncAccess();
		  observeTarget();

		  /* la barre ne doit pas flotter par-dessus le footer atteint au scroll */
		  var footer = document.querySelector('.shopify-section-group-footer-group');
		  if (footer && typeof window.IntersectionObserver === 'function') {
			new IntersectionObserver(function (entries) {
			  entries.forEach(function (entry) { root.classList.toggle('is-footer-visible', entry.isIntersecting); });
			  syncAccess();
			}, { threshold: 0 }).observe(footer);
		  }

		  if (selector) {
			document.addEventListener('product:product-reload-complete', function () {
			  var fresh = null;
			  try { fresh = document.querySelector(selector); } catch (e) { fresh = null; }
			  if (fresh === target) return;
			  target = fresh;
			  observeTarget();
			});
		  }
	  
		  /* la barre ne doit pas glisser AVANT d'être posée : la transition ne
			 s'installe qu'au frame suivant (.is-ready) */
		  window.requestAnimationFrame(function () { root.classList.add('is-ready'); });
	  
		  /* ---- passage en desktop : le panneau déplié n'a plus lieu d'être --- */
		  var wasMobile = isMobile();
		  window.addEventListener('resize', function () {
			if (!isMobile() && root.classList.contains('is-expanded')) expand(false);
			if (isMobile() !== wasMobile) {
			  wasMobile = isMobile();
			  observeTarget();
			}
		  });
	  
		  /* → ici : cart/add.js avec la variante sélectionnée (.mm-sticky__cta) */
		}
	  
		function setupAll(scope) {
		  (scope || document).querySelectorAll('.mm-sticky').forEach(setup);
		}
	  
		setupAll();
		window.MmStickyCta = { setup: setupAll };
	  })();